import { Form, Spin } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../contractbooking.config";
import ContractInformationForm from "./components/ContractInformationForm";
import CounterpartyForm from "./components/CounterPartyForm";
import TermsForm from "./components/TermsForm";
// import PreviewForm from "./components/Preview";
import dayjs from "dayjs";
import "../../../../assets/styles/InterbankPlacement.css";
import StepsCard from "../../component/StepsCard";
import StepsComponent from "../../component/StepsComponent";
import SuccessModal from "../../component/SuccessModal";
import PreviewForm from "./components/PreviewForm";
import ChargeDetails from "./components/ChargeDetails";
// import styles from "../../../../assets/styles/styles";

const CreateInterBankContract = (props) => {
  const { userData } = props;
  const { session } = userData;
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();
  const [useForm] = Form.useForm();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [customerParam, setCustomerParam] = useState({});
  const [searchParam, setSearchParam] = useState("");
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [productData, setProductData] = useState([]);
  const [interestTypeOptions, setInterestTypeOptions] = useState([]);
  const [custodianOptions, setCustodianOptions] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [placementTypeOptions, setPlacementTypeOptions] = useState([]);
  const [collateralTypeOptions, setCollateralTypeOptions] = useState([]);
  const [interstRateTypeData, setInterstRateTypeData] = useState([]);
  const [counterPartyData, setCounterPartyData] = useState([]);
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [customerData, setCustomerData] = useState([]);
  const [customerInfo, setCustomerInfo] = useState({});
  const [fieldOfficerData, setFieldOfficerData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [counterPartyDetails, setCounterPartyDetails] = useState(null);
  const [counterPartyExists, setCounterPartyExists] = useState(false);
  const [sendDealConfirmation, setSendDealConfirmation] = useState(false);
  const [isCreatingContract, setIsCreatingContract] = useState(false);
  const [isCreateButton, setIsCreateButton] = useState(true);
  const [isCreateScreen, setIsCreateScreen] = useState(true);
  const [defaultCurrency, setDefaultCurrency] = useState("");
  const [contractRef, setContractRef] = useState("");
  const [chargeData, setChargeData] = useState(null);

  const updateFormData = (section, data) => {
    setFormData({
      ...formData,
      [section]: data,
    });
  };

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    contractInformation: null,
    terms: null,
    counterParty: null,
  });

  useEffect(() => {
    getTemplate();
    getInterbankProductTemplate();
  }, []);

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }

    setSearchParam(searchKey);
  }

  const onSearch = () => {
    //clear form

    setIsProductSelected(false);
    useForm.resetFields();

    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }
    const params = {
      exactMatch: true,
      query: searchParam.trim(),
      resource: "clients,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.SearchCustomer, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        // setSearchParam("");
      } else {
        const objList = res;
        // console.log(searchParam);

        // console.log(objList?.filter((item) => item?.entityAccountNo === searchParam));

        let tempCustomer = [];

        objList
          ?.filter((item) => item?.entityAccountNo === searchParam)
          .forEach((element) => {
            tempCustomer.push({
              label: `${element.entityName || ""} - ${
                element.entityMobileNo || ""
              }`,
              value: element.entityId || "",
              entityAccountNo: element.entityAccountNo || "",
              entityId: element.entityId || "",
              entityMobileNo: element.entityMobileNo || "",
              entityName: element.entityName || "",
              entityType: element.customerType || "",
            });
          });

        // console.log(tempCustomer[0]);
        // return;

        if (tempCustomer[0] === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        setCustomerData(tempCustomer);
        getCustomerDetailById(tempCustomer[0]);
        getAccountOverviewList(tempCustomer[0]);
        getClientCounterParty(tempCustomer[0]);
        setCustomerParam(tempCustomer[0]);
        // setShowDetailsForm(true);
        // setIsLoading(false);
      }
    });
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const onFinishContractForm = (values) => {
    console.log(values);

    setFormData({ ...formData, contractInformation: values });

    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    console.log(values);

    setFormData({ ...formData, terms: values });
    setCurrent(current + 1);
  };

  const onFinishCounterPartyForm = (values) => {
    console.log(values);

    setFormData({
      ...formData,
      counterParty: values,
    });
    setCurrent(current + 1);
  };

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      apiConfig.InterbankContractTemplate,
      (err, res) => {
        console.log(res);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err);
        } else {
          const objList = res;
          let tempProducts = [];
          let tempInterestRateType = [];
          let tempCounterPartyOptions = [];
          let tempPlacementTypes = [];
          let tempCollateralTypes = [];

          objList?.productOptions
            ?.filter((item) => item?.status?.text === "Active")
            .forEach((element) => {
              tempProducts.push({
                value: element.id,
                // label: element.name ? `${element.name} (${element.id})` : "",
                label: element.productName || "",
              });
            });

          objList?.interestRateTypeOptions?.forEach((element) => {
            tempInterestRateType.push({
              value: element.value,
              label: element.text || "",
            });
          });

          objList?.counterpartyOptions?.forEach((element) => {
            tempCounterPartyOptions.push({
              value: element.id,
              label: element.centralBankCode || "",
              bankName: element.bankName || "",
              id: element.id || "",
              swiftCode: element.swiftCode || "",
              allowRTGS: element.allowRTGS || "",
              institutionCode: element.institutionCode || "",
              placementDealAccountLcy: element.placementDealAccountLcy || "",
              bankCode: element.centralBankCode || "",
              contactEmail: element.contactEmail || "",
              contactPhoneNo: element.contactPhoneNo || "",
              currentLimitUtilizationLcy:
                element.currentLimitUtilizationLcy || "",
              maxLimitAmountLcy: element.maxLimitAmountLcy || "",
              status: element?.status?.value || "",
            });
          });

          objList?.placementTypeOptions?.forEach((element) => {
            tempPlacementTypes.push({
              value: element.value,
              label: element.text,
            });
          });

          objList?.collateralTypeOptions?.forEach((element) => {
            tempCollateralTypes.push({
              value: element.id,
              label: element.name,
            });
          });

          setProductData(tempProducts);
          setInterstRateTypeData(tempInterestRateType);
          setCounterPartyData(tempCounterPartyOptions);
          setPlacementTypeOptions(tempPlacementTypes);
          setCollateralTypeOptions(tempCollateralTypes);
        }
      }
    );
  }

  const getInterbankProductTemplate = () => {
    // START LOAD
    setIsLoading(true);

    let body = { session };

    BOM.FetchReqAction(
      body,
      apiConfig.InterBankPlacementTemplate,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          // setInterbankProductTemplate(res);
          const objList = res;
          let tempInterestTypes = [];
          let tempCustodians = [];
          let tempCurrencies = [];

          const filteredInterestTypes = objList.interestTypes.filter(
            (items) =>
              items.text === "Simple Interest" ||
              items.text === "Compound Interest"
          );

          filteredInterestTypes.forEach((elements) => {
            tempInterestTypes.push({
              value: elements.value,
              label: elements.text,
            });
          });

          objList?.custodians?.forEach((element) => {
            tempCustodians.push({
              value: element.id,
              label: element.name,
            });
          });

          objList?.currencies?.forEach((element) => {
            tempCurrencies.push({
              value: element?.code,
              label: `${element?.displaySymbol || element?.code} ${
                element?.displayLabel
              }`,
              symbol: element?.displaySymbol,
            });
          });

          setInterestTypeOptions(tempInterestTypes);
          setCustodianOptions(tempCustodians);
          setCurrencies(tempCurrencies);

          setIsLoading(false);
        }
      }
    );
  };

  const onChangeProduct = (productParam) => {
    const url = `${apiConfig.InterBankPlacementProducts}/${productParam}`;

    let body = {
      session,
    };

    setIsLoading(true);
    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        setTemplateProdDetail(res);
        const objList = res;
        let tempProducts = [];
        let tempFieldOfficer = [];
        let tempCurrency = objList?.currencyCode;
        let tempPenaltyOptions = [];

        console.log(objList);

        useForm.setFieldsValue({
          // Contract Information
          productCode: objList?.productCode || "",
          productName: objList?.productName || "",
          productType: objList?.productType?.text || "",
          currencyCode: objList?.currencyCode || "",
          custodian: objList?.custodian?.id || null,

          // Terms
          decimalPlaces: objList?.currency?.decimalPlaces || 0,
          inMultiplesOf: objList?.currency?.inMultiplesOf || 1,
          submittedOnDate: dayjs(),
          nominalAnnualInterestRate: objList?.nominalAnnualInterestRate || 0,

          // Terms Configuration
          minTenor: objList?.minTenor || 0,
          maxTenor: objList?.maxTenor || 0,
          defaultTenor: objList?.defaultTenor || 0,
          allowRollover: objList?.allowRollover || false,
          autoRollover: objList?.autoRollover || false,
          backdatedValueDateAllowed:
            objList?.backdatedValueDateAllowed || false,
          allowEarlyTermination: objList?.allowEarlyTermination || false,
          earlyTerminationWithPenalty:
            objList?.earlyTerminationWithPenalty || false,
          maturityDateAdjustment: objList?.maturityDateAdjustment?.value || "",
          allowPlacementFee: objList?.allowPlacementFee || false,
          placementFeeWithPenalty: objList?.placementFeeWithPenalty || false,
          placementFeeCharges: objList?.penaltyCharge?.name || "--",

          // Interest Configuration
          // interestType: objList?.interestType?.value || "",
          interestType: objList?.interestType?.value ?? "",
          interestRateType: objList?.interestRateType?.text || "",
          interestRate: objList?.defaultRate || 0,
          interestCalculationBasis:
            objList?.interestCalculationBasis?.text || "",
          interestPostingType: objList?.interestPostingType?.text || "",
          allowTax: objList?.allowTax || false,
          // taxGroup: objList?.taxGroup || 0,
          taxGroup: objList?.taxGroup?.name || "--",

          // Counterparty Settings
          counterpartyTypes:
            objList?.counterpartyTypes
              ?.map((type) => type?.id)
              .filter(Boolean) || [],
          kycRequirements: objList?.kycRequirements?.[0]?.id || "",
          activateDealConfirmation: objList?.activateDealConfirmation || false,
          allowSwiftCode: objList?.allowSwiftCode || false,
          allowRTGS: objList?.allowRTGS || false,

          // Compliance Settings
          centralBankReports:
            objList?.centralBankReports
              ?.map((report) => report?.id)
              .filter(Boolean) || [],
          riskLimit: objList?.riskLimit?.toString() || "0",
          mandatoryAMLScreening: objList?.mandatoryAMLScreening || false,
        });

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.fieldOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setChargeData({
          allowTax: objList?.allowTax,
          taxGroup: objList?.taxGroup,
        });

        // setProductData(tempProducts);
        setFieldOfficerData(tempFieldOfficer);
        setDefaultCurrency(tempCurrency);
        setIsProductSelected(true);
        setIsLoading(false);
      }
    });
  };

  const getCustomerDetailById = (param) => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${param.entityId}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempCurrentCustomer = {
          key: objDetail?.id,
          id: objDetail?.id,
          name: objDetail?.displayName ? objDetail?.displayName : "-",
          clientno: objDetail?.accountNo ? objDetail?.accountNo : "-",
          externalId: objDetail?.externalId ? objDetail?.externalId : "-",
          status: objDetail?.status ? objDetail?.status.value : "-",
          branch: objDetail?.officeName ? objDetail?.officeName : "-",
          staff: objDetail?.staffName ? objDetail?.staffName : "-",
          branchId: objDetail?.officeId ? objDetail?.officeId : "-",
          customerType: objDetail?.legalForm ? objDetail?.legalForm.value : "-",
        };

        setCustomerInfo(tempCurrentCustomer);

        setShowDetailsForm(true);

        // setCurrentCustomerDetails(tempCurrentCustomer);
        setIsLoading(false);
      }
    });
  };

  const getAccountOverviewList = (param) => {
    const url = `${apiConfig.Clients}/${param.entityId}/accounts`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempSavingsArray = [];

        // prepare table for savings, current, term deposit accounts
        objList?.savingsAccounts
          ?.filter((item) => item?.status?.active === true)
          ?.forEach((element) => {
            tempSavingsArray.push({
              value: element?.id,
              label: `${element?.accountNo || "-"} - ${
                element?.productName || "-"
              }`,
              // Keep all original data
              ...element,
              key: element?.id,
              id: element?.id,
              accountNo: element?.accountNo || "-",
              productName: element?.productName || "-",
              status:
                element?.status.active === true
                  ? "Active"
                  : element?.status.active === false
                  ? "Closed"
                  : "-",
            });
          });
        // setSavingsList(tempSavingsArray);
      }
    });
  };

  const getClientCounterParty = (param) => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.Counterparty}/${param.entityId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        setCounterPartyExists(false);
        setCounterPartyDetails(null);
        // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);
        setCounterPartyExists(true);
        const objList = res;
        setCounterPartyDetails(objList);

        useForm.setFieldsValue({
          // Counterparty Settings
          bankName: objList?.bankName,
          bankCode: objList?.centralBankCode,
          status: objList?.status?.value,
          institutionCode: objList?.institutionCode,
          swiftCode: objList?.swiftCode,
          currentLimitUtilizationLcy: objList?.currentLimitUtilizationLcy,
          maxLimitAmountLcy: objList?.maxLimitAmountLcy,
          allowSwiftCode: objList.allowSwiftCode,
          allowRTGS: objList.allowRTGS,
          email: objList?.contactEmail,
          externalDealAccountNumber: objList.externalDealAccountNumber,
          kycStatus: objList?.kycStatus?.value,
        });
      }
    });
  };

  const handleSubmit = (formValues) => {
    // Here you would submit the form data to your API

    console.log("Submitting form data:", formData);
    formValues = {
      ...formData.contractInformation,
      ...formData.terms,
      ...formData.counterParty,
    };
    console.log(formValues);

    const payloadData = {};

    payloadData.productId = templateProdDetail.id;
    payloadData.clientId = customerInfo.id;
    payloadData.counterpartyId = counterPartyDetails.id;
    payloadData.submittedOnDate = BOM.DateTime(
      formValues.startDate,
      "only-date"
    );
    payloadData.custodian = formValues.custodian;
    payloadData.placementType = formValues.placementType;
    payloadData.collateralTypeId = formValues.collateralTypeId;
    payloadData.collateralVolume = formValues.collateralVolume;
    payloadData.collateralNumber = formValues.collateralNumber;
    payloadData.collateralValue = formValues.collateralValue;
    payloadData.collateralCurrency = formValues.collateralCurrency;
    payloadData.collateralMaturityDate = BOM.DateTime(
      formValues.maturityDate,
      "only-date"
    );
    payloadData.collateralIdentifier = formValues.collateralIdentifier;
    payloadData.interestType = formValues.interestType;
    payloadData.interestRate = formValues.interestRate;
    payloadData.tenor = formValues.defaultTenor;
    payloadData.amount = formValues.amountPlaced;
    payloadData.allowRollover = formValues.allowPlacementFee;
    payloadData.autoRollover = formValues.allowTax;
    payloadData.dealConfirmation = formValues.sendDealConfirmation;

    // console.log(payloadData);
    // return;

    const body = {
      ...payloadData,
      method: "POST",
      session,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.InterbankContract, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        setIsModalVisible(true);

        setContractRef(res.contractReferenceId);

        //STOP LOAD
        setIsLoading(false);
      }
    });
    // Show success modal
  };

  const handleGoBack = () => {
    navigate("/interbank-contract");
  };

  // Define the content for each step
  const stepsContent = [
    {
      title: "Contract Information",
      component: (
        <ContractInformationForm
          onSearch={onSearch}
          searchParam={searchParam}
          customerInfo={customerInfo}
          currencyData={currencyData}
          showDetailsForm={showDetailsForm}
          handleSearchInTable={handleSearchInTable}
          onFinish={onFinishContractForm}
          form={useForm}
          initialValues={formData.contractInformation}
          onChangeProduct={onChangeProduct}
          productData={productData}
          isProductSelected={isProductSelected}
          userData={userData}
          isCreateScreen={isCreateScreen}
          defaultCurrency={defaultCurrency}
          custodianOptions={custodianOptions}
          placementTypeOptions={placementTypeOptions}
          collateralTypeOptions={collateralTypeOptions}
          currencies={currencies}
        />
      ),
    },
    {
      title: "Terms",
      component: (
        <TermsForm
          onFinish={onFinishTermsForm}
          form={useForm}
          initialValues={formData.terms}
          // currencyData={currencyData}
          templateProdDetail={templateProdDetail}
          interstRateTypeData={interstRateTypeData}
          interestTypeOptions={interestTypeOptions}
          defaultCurrency={defaultCurrency}
        />
      ),
    },
    {
      title: "Charge Details",
      component: <ChargeDetails chargeData={chargeData} />,
    },
    {
      title: "Counterparty Information",
      component: (
        <CounterpartyForm
          onFinish={onFinishCounterPartyForm}
          form={useForm}
          initialValues={formData.terms}
          // currencyData={currencyData}
          templateProdDetail={templateProdDetail}
          counterPartyData={counterPartyData}
          setSendDealConfirmation={setSendDealConfirmation}
          sendDealConfirmation={sendDealConfirmation}
          defaultCurrency={defaultCurrency}
          // onChangeBranch={onChangeBranch}
        />
      ),
    },
    {
      title: "Preview",
      component: (
        <PreviewForm
          formData={formData}
          templateProdDetail={templateProdDetail}
          productData={productData}
          interestTypeOptions={interestTypeOptions}
          custodianOptions={custodianOptions}
          placementTypeOptions={placementTypeOptions}
          collateralTypeOptions={collateralTypeOptions}
          currencies={currencies}
          onCreateProduct={handleSubmit}
          isCreateButton={isCreateButton}
          onGoBack={handleGoBack}
          chargeData={chargeData}
        />
      ),
    },
  ];

  const next = () => {
    const stepsUsingForm = [0, 1, 3]; // indices of steps

    if (stepsUsingForm.includes(current)) {
      useForm.submit(); // only those steps trigger onFinish
    } else {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    const prevStep = current - 1;
    setCurrent(prevStep);

    // Remove the last completed step if going back
    setCompletedSteps((prev) => {
      const updated = prev.filter((stepIndex) => stepIndex < prevStep);
      return updated;
    });
  };

  return (
    <MainLayout pageItems={staticConfig.newcontractbookingInterbankPlacement}>
      <TopContent
        pageTitle={labelConfig.manageContractBookingInterbankplacement}
        createPageTitle={labelConfig.createContractBookingInterbankplacement}
      />
      <Spin spinning={isLoading} size="large">
        <div
          className="contract-form-container"
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            height: "720px",
            widtth: "100%",
          }}
        >
          {/* Left side - Vertical steps */}
          <StepsComponent
            steps={stepsContent}
            current={current}
            completedSteps={completedSteps}
          />

          <StepsCard
            current={current}
            onNext={next}
            onPrev={prev}
            totalSteps={5}
            nextLabel={`Next - ${stepsContent[current + 1]?.title || ""}`}
            onSubmit={handleSubmit}
            submitLabel="Create Contract"
            onGoBack={handleGoBack}
          >
            {stepsContent[current].component}
          </StepsCard>

          <SuccessModal
            visible={isModalVisible}
            onClose={handleGoBack}
            isCreateButton={isCreateButton}
            contractRef={contractRef}
            successMessage={
              "Your Interbank Placement Contract has been created successfully."
            }
          />
        </div>
      </Spin>
    </MainLayout>
  );
};

export default CreateInterBankContract;
